import React from "react"
import {
    componentStyles,
    MultiMediaDisplay,
    MediaDisplayType,
    UploadCareImageVariant,
} from "@mallardbay/lib-react-components"

import HeaderButtons from "~components/pages/listing/mobile-header-buttons"
import BackButton from "~components/shared/back-button"
import ResponsiveBlock from "~components/shared/responsive-block"
import type { PublicOutfitterFieldsFragment } from "~graphql/generated/graphql"
import { useTabletMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"
import { HEADER_IMAGE_WIDTH } from "~config/constants"

interface Props {
    readonly outfitter: PublicOutfitterFieldsFragment
}

export default function OutfitterHeader({ outfitter }: Props) {
    const styles = useStyles()
    const { photos, video } = outfitter
    const { isLargerThanTablet } = useTabletMediaQueries()

    const type = isLargerThanTablet
        ? MediaDisplayType.GRID
        : MediaDisplayType.CAROUSEL

    return (
        <>
            <ResponsiveBlock
                noPadding={!isLargerThanTablet}
                style={styles.root}
            >
                {isLargerThanTablet && <BackButton />}
                <MultiMediaDisplay
                    images={photos}
                    video={video?.hosted || video?.social}
                    type={type}
                    imageWidth={HEADER_IMAGE_WIDTH}
                    imageVariant={UploadCareImageVariant.XL_HORIZONTAL}
                    shouldDisableImageHoverFilter
                />
            </ResponsiveBlock>
            <HeaderButtons />
        </>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            marginTop: { md: 6 },
        },
    })
}
